import React from 'react';
import arrow_back from '../Icons/svg/arrow_back.svg';
import { sendEvent } from '../../utils/tracking';

import './WebHeader.css';
const backBtnClick = () => {
  sendEvent(
    'back_button',
    {
      event_action: 'click',
      event_category: 'top_nav',
      screen_name: 'find_load',
      target_product: 'marketplace',
    },
    true,
  );
};
const WebHeaderDetail = ({ title, onClick, className, mainContainerClass, pageClass }: any) => {
  return (
    <>
      <div className={`headerBlock ${pageClass}`}>
        <div className={`webHeaderMainContainer ${mainContainerClass}`}>
          <div className="headerContentDetails" onClick={onClick}>
            <img src={arrow_back} onClick={backBtnClick} alt="" />
            <p className={className}>{title}</p>
          </div>
        </div>
      </div>
    </>
  );
};
export default WebHeaderDetail;
